import type { CrehanaTFunction } from '@crehana/i18n';
import { z } from 'zod';

export const useChangePasswordSchema = (t: CrehanaTFunction) =>
  z
    .object({
      password: z
        .string({ required_error: t('CHANGE_PASSWORD_FORM_REQUIRED') })
        .regex(/^\S*$/, { message: t('PASSWORD_CANNOT_CONTAIN_SPACES') })
        .min(6, { message: t('CHANGE_PASSWORD_FORM_MIN_LENGTH') })
        .max(50, { message: t('CHANGE_PASSWORD_FORM_MAX_LENGTH') }),
      confirmPassword: z
        .string({ required_error: t('CHANGE_PASSWORD_FORM_REQUIRED') })
        .regex(/^\S*$/, { message: t('PASSWORD_CANNOT_CONTAIN_SPACES') }),
    })
    .superRefine((data, ctx) => {
      if (data.password !== data.confirmPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('PASSWORD_DOES_NOT_MATCH'),
          path: ['confirmPassword'],
        });
      }
    });

export type TChangePasswordSchema = z.infer<
  ReturnType<typeof useChangePasswordSchema>
>;
